var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"/images/common/IconCloseRed.svg"},on:{"click":function($event){return _vm.$emit('clicked')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }